import React from 'react';
import PropTypes from 'prop-types';

import SVG from '@glowforge/gf-styled/components/svg';
import { SocialCardWidget } from '@glowforge/gf-styled/contentful-widgets';

import {
  CardsWrapper,
  TextWrapper,
  Title,
  Wrapper,
} from './social-cards-rebrand.styles';

const SocialCards = ({ backgroundColor, cards, icon, title }) => (
  <Wrapper backgroundColor={backgroundColor} showOverlay={false} variant='full'>
    <TextWrapper>
      {icon ? <SVG svgAsset={icon} height={30} width={30} /> : null}
      {title ? <Title>{title}</Title> : null}
    </TextWrapper>
    <CardsWrapper>
      {cards?.map((card) => (
        <SocialCardWidget
          key={card.fields?.id || card.fields?.lookupId}
          model={card}
        />
      ))}
    </CardsWrapper>
  </Wrapper>
);

SocialCards.propTypes = {
  backgroundColor: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.shape({})),
  title: PropTypes.string,
  icon: PropTypes.shape({}),
};

SocialCards.defaultProps = {
  backgroundColor: 'white',
  cards: [],
  title: null,
  icon: null,
};

export default SocialCards;
